/**
 * OneTrust opt-out consent: scripts load until user opts out.
 * Exposes window.hasConsent('marketing'|'analytics').
 */
(function () {
  var w =
    /** @type {Window & { __consentConfig?: { marketingCategoryId?: string; analyticsCategoryId?: string }; OptanonActiveGroups?: string; hasConsent?: (c: string) => boolean }} */ (
      window
    );
  var config = w.__consentConfig || {};
  var ids = {
    marketing: config.marketingCategoryId || 'C0004',
    analytics: config.analyticsCategoryId || 'C0002',
  };

  /** @param {'marketing'|'analytics'} category */
  function hasConsent(category) {
    var groups = typeof w.OptanonActiveGroups === 'string' ? w.OptanonActiveGroups : '';
    if (!groups) return true;
    var id = ids[/** @type {keyof typeof ids} */ (category)];
    return id ? groups.indexOf(id) !== -1 : false;
  }

  w.hasConsent = hasConsent;

  function fire() {
    try {
      w.dispatchEvent(new CustomEvent('consent-ready', { detail: {} }));
    } catch (e) {}
  }

  // Re-fire whenever the user changes their consent choices in the banner.
  window.addEventListener('OneTrustGroupsUpdated', fire);

  if (typeof w.OptanonActiveGroups !== 'undefined') fire();
  else {
    var t = setInterval(function () {
      if (typeof w.OptanonActiveGroups !== 'undefined') (clearInterval(t), fire());
    }, 100);
    setTimeout(function () {
      clearInterval(t);
      fire();
    }, 5000);
  }
})();
